import { CompactType, DisplayGrid, GridsterConfig, GridType } from 'angular-gridster2';

export const gridsterConfig: GridsterConfig = {
  gridType: GridType.VerticalFixed,
  compactType: CompactType.None,
  displayGrid: DisplayGrid.Always,
  pushItems: true,
  margin: 0,
  minCols: 3,
  maxCols: 100,
  minRows: 1,
  maxRows: 100,
  maxItemCols: 100,
  minItemCols: 1,
  maxItemRows: 100,
  minItemRows: 1,
  maxItemArea: 2500,
  minItemArea: 1,
  defaultItemCols: 1,
  defaultItemRows: 1,
  fixedColWidth: 105,
  fixedRowHeight: 105,
  outerMargin: false,
  draggable: { enabled: true },
  resizable: { enabled: true },
};

export const panelLabelMap = {
  comments: 'Comments',
  'crm-table-panel': 'Related Objects Table',
  form: 'Form',
  images: 'Gallery',
  matrix: 'Tables',
  table: 'Related Objects Table',
};
